<div class="w-full  text-white flex  items-center app-header px-5 justify-between h-[8vh]">

    <div>
        <img src="assets/logo.png" alt="logo" class="h-[5vh]" />
    </div>

    <div class="flex items-center gap-5">

    

        <div class="hidden sm:flex icon-container">
            <div>
                <i class="pi pi-bell cursor-pointer" pBadge value="0" (click)="op.toggle($event)"></i>
            </div>

      
        </div>

        <div class="flex items-center gap-1 ">
            <div class="hidden md:flex">
                {{userProfileName}}
            </div>
            <div style="background-color: #fff;"
                class="flex items-center justify-center  h-10 w-10 rounded-full ml-0 sm:ml-5 cursor-pointer">

                <div *ngIf="profilePicture === '' || profilePicture == null || profilePicture === undefined ">
                    <p-avatar label="{{getInitials()}}" shape="circle" class="h-4 w-4" (click)="menu.toggle($event)" />
                </div>

                <div *ngIf="profilePicture != ''" style="display: flex;">
                    <p-avatar [image]="profilePicture" shape="circle" class="h-4 w-4" (click)="menu.toggle($event)" />
                </div>




                <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
            </div>
            <div>
                <div style="color: #fff;border: 1px solid #fff; padding: 7px 12px; border-radius: 5px; font-size: 14px; text-transform: uppercase; letter-spacing: 3px;" class="flex text-sm font-semibold text-surface-900 dark:text-surface-0 ml-2">
                    {{environmentName}}
                </div>
            </div>
        </div>


        <div class="notification-popover">
            <p-popover #op [style]="myStyle">
                <div class="flex flex-col gap-4 w-[28rem] p-3">
                    <div>
                        <span class="font-medium text-surface-900 dark:text-surface-0 block mb-1">Notifcations</span>
                    </div>
                    <div>
                        <div class="flex justify-center items-center font-bold text-[15px] mb-6 mt-4">
                            No notifications available
                        </div>
                      
                    </div>
                </div>
            </p-popover>
        </div>

    </div>




</div>


<p-dialog [modal]="true" [(visible)]="showProfile" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <app-user-profile (closeDialog)="handleCloseProfile()"></app-user-profile>
</p-dialog>

<app-floating-configurator />